import axios from "axios";
import { EXTERNAL_API_URL } from "../index";

export const GET_STATISTICAL_DATA_URL = "StatisticalData/get-statistical-data";

export function getStatisticalData() {
    return axios.get(EXTERNAL_API_URL + GET_STATISTICAL_DATA_URL);
}
  